import { render } from "./CookiesDropInputObject.vue?vue&type=template&id=ffd6b8b6&scoped=true"
import script from "./CookiesDropInputObject.vue?vue&type=script&lang=js"
export * from "./CookiesDropInputObject.vue?vue&type=script&lang=js"

import "./CookiesDropInputObject.vue?vue&type=style&index=0&id=ffd6b8b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffd6b8b6"]])

export default __exports__